import { AlertService } from "./../components/alert/alert.svc";
import { SelectionModel } from "@angular/cdk/collections";
import { MatDialog } from "@angular/material/dialog";
import { ServicesData } from "../services/services.data";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ToraxHttp } from "../utils/custom-http.svc";
import { IndexService } from "../services/index-service";
import { AssistancesData } from "./assistances.data";
import { SubscriptionLike } from "rxjs";

@Component({
  selector: "assistances-list",
  templateUrl: "assistances-list.tmpl.html",
})
export class AssistancesList implements OnInit, OnDestroy {
  constructor(
    private assistancesData: AssistancesData,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    public servicesData: ServicesData,
    public _matDialog: MatDialog,
    private toraxHttp: ToraxHttp,
    private alert: AlertService
  ) {
    let sub = this.toraxHttp!.updatedEvent.subscribe(i => {
      if (this.indexService && i.type.indexOf('/assistances') > -1) {
        this.indexService.getList();
      }
    });
    this.subscriptions.push(sub);
  }

  subscriptions: SubscriptionLike[] = [];
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  groupingColumn = '';
  groupingOrderColumn = '';
  expandedRowID;
  displayedColumns: string[] = ["buttons", "assistanceID", "contactName", "assistanceDate", "amount", "reason", "comment", "donationCategoryTitle"];

  defaultvalues: any[];
  selectedItems;
  indexService: IndexService;
  resultsLength = 0;
  isRateLimitReached = false;
  searchAssistancesListForm: FormGroup;

  actualMinusHeight = '185';
  @Input("contactID") public contactID?: number | null = null;
  @Input("assistancesSetID") public assistancesSetID?: number | null = null;

  @Output() selectedRowsChange = new EventEmitter<any>();
  public selection = new SelectionModel<number>(true, []);

  toggleExpandableSymbol(id): void {
    this.expandedRowID = this.expandedRowID === id ? null : id;
  }

  isChecked(row: any): boolean {
    const found = this.selection.selected.find(
      (el: any) => el.assistanceID === row.assistanceID
    );
    if (found) {
      return true;
    }
    return false;
  }

  rowToggle(row) {
    this.selection.toggle(row);
    row.selected = !row.selected;
  }

  addNew() {
    this.router.navigate([{ outlets: { popup: ["add"] } }]);
  }

  openSelectedRow(assistanceID) {
    this.router.navigate(["", { outlets: { popup: ["assistances", assistanceID] } }]);
  }

  public createAndPrintAssistancesLetters(): void {
    let ids = this.searchAssistancesListForm.controls["selectedRows"].value
      .map((x) => x)
      .join();
    if (!ids) {
      alert("לא נבחרו רשומות להדפסה");
    } else {
      this.assistancesData
        .createAndPrintAssistancesLetters(ids)
        .subscribe((data) => {
          let popupWinindow: any = window.open(
            "",
            "_blank",
            "scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no"
          );
          popupWinindow.document.open();
          popupWinindow.document.write(
            '<html><head><style type="text/css">.MsoNormal { margin-top: 0px; margin-bottom: 0px;} @page { size: letter; margin: 0; } @media print { html, body { width: 210mm; height: 297mm; } .page { page-break-after: always; } }  </style></head><body  onload="window.print()"><div>' +
            (<any>data).value +
            "</div></body></html>"
          );
          popupWinindow.document.close();
        });
    }
  }


  private initForm() {
    this.searchAssistancesListForm = this.formBuilder.group({
      page: [1],
      pageRows: [20],
      query: [],
      contactID: [],
      contactName: [],
      donationCategoryID: [],
      donationCategoryTitle: [],
      assistanceTypeID: [],
      assistanceTypeTitle: [],
      selectedRows: [],
      orders: this.formBuilder.array([]),
    });

    this.selection.changed.subscribe((x) => {
      this.searchAssistancesListForm.controls["selectedRows"].setValue(
        x.source.selected.map((x: any) => x.assistanceID)
      );
      this.selectedRowsChange.emit(x.source.selected);
    });
  }

  ngOnInit() {
    this.initForm();

    this.activatedRoute.params.forEach((params: Params) => {
      this.contactID = +params["contactID"] || null;
      this.assistancesSetID = +params["assistancesSetID"] || null;
    });

    let item = sessionStorage.getItem(this.router.url);
    if (item) {
      let frm = JSON.parse(sessionStorage.getItem(this.router.url) || "");
      this.searchAssistancesListForm.patchValue(frm);
    }

    this.searchAssistancesListForm.updateValueAndValidity();
    this.selection.isSelected = this.isChecked.bind(this);
    let params = [
      { key: "contactID", value: this.contactID },
      { key: "assistancesSetID", value: this.assistancesSetID },
    ];
    this.indexService = new IndexService(this.searchAssistancesListForm, params, this.assistancesData, this.router, this.defaultvalues, '', this.groupingColumn, this.groupingOrderColumn);
    this.indexService.getList();

    if (this.contactID) {
      this.actualMinusHeight = '362';
    }
  }
}
